module.exports = __webpack_public_path__ + "img/3-10-2.a117b4f6.png";